import React from 'react';
import CopyButton from './CopyButton';

// T0 — Bloc de code partagé (fond sombre constant + bouton copier).
export const CodeBlock = ({ code, language = '', className = '' }) => {
  const text = typeof code === 'string' ? code : JSON.stringify(code, null, 2);
  return (
    <div className={`relative rounded-lg bg-gray-900 text-gray-100 ${className}`}>
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-700/60">
        <span className="text-xs uppercase tracking-wide text-gray-400">{language || 'code'}</span>
        <CopyButton text={text} className="hover:bg-gray-700 text-gray-300" />
      </div>
      <pre className="p-4 overflow-x-auto text-sm leading-relaxed">
        <code>{text}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
